import React from 'react';
import { BookOpenIcon, CheckCircleIcon, FileTextIcon, ShieldIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export const Offer = () => {
  return <section id="offer" className="w-full bg-white py-12 px-4 md:px-8" data-id="element-201">
      <div className="max-w-5xl mx-auto" data-id="element-202">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-203">
          To nie było to, czego się spodziewałam
        </h2>
        {/* E-book description */}
        <div className="bg-white rounded-lg shadow-md p-6 md:p-8 mb-12 border border-gray-200" data-id="element-204">
          <div className="md:flex items-start" data-id="element-205">
            <div className="md:w-1/3 mb-6 md:mb-0 md:mr-8" data-id="element-206">
              <div className="relative" data-id="element-207">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5pGpQfPkSpzXL3ToTbKWSz/8.png" alt="E-book Nie Zapomnij o Sobie" className="rounded-lg shadow-lg w-full" data-id="element-208" />
                <div className="absolute -top-4 -right-4 bg-red-600 text-white py-2 px-4 rounded-full shadow-lg transform rotate-12" data-id="element-209">
                  <p className="text-sm font-bold" data-id="element-210">Bestseller!</p>
                </div>
              </div>
              <div className="mt-4 bg-blue-50 rounded-lg p-4 text-center" data-id="element-211">
                <p className="text-sm text-gray-700" data-id="element-212">
                  <span className="font-bold" data-id="element-213">2,847</span> zadowolonych
                  czytelniczek!
                </p>
              </div>
            </div>
            <div className="md:w-2/3" data-id="element-214">
              <p className="text-gray-700 mb-4" data-id="element-215">
                Żadnych tabelek do wypełniania. Żadnych "porad" w stylu "wstawaj
                o 5 rano i medytuj". Żadnego coachingowego bełkotu o "byciu
                najlepszą wersją siebie".
              </p>
              <p className="text-gray-700 mb-6" data-id="element-216">
                Zamiast tego - prosty, ludzki język. Jakby przyjaciółka do mnie
                mówiła:
              </p>
              <div className="bg-pink-50 border-l-4 border-pink-500 p-4 my-6" data-id="element-217">
                <p className="text-gray-700 italic font-bold" data-id="element-218">
                  "Nie jesteś słaba. Jesteś wyczerpana. I to nie Twoja wina."
                </p>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mt-8 mb-4" data-id="element-219">
                E-book zawierał:
              </h3>
              <div className="space-y-3" data-id="element-220">
                <div className="flex items-start" data-id="element-221">
                  <BookOpenIcon className="h-5 w-5 text-pink-600 mr-2 mt-1 flex-shrink-0" data-id="element-222" />
                  <p className="text-gray-700" data-id="element-223">
                    Kompletny protokół 15-minutowej regeneracji (krok po kroku)
                  </p>
                </div>
                <div className="flex items-start" data-id="element-224">
                  <BookOpenIcon className="h-5 w-5 text-pink-600 mr-2 mt-1 flex-shrink-0" data-id="element-225" />
                  <p className="text-gray-700" data-id="element-226">
                    Naukowe wyjaśnienie dlaczego inne metody nie działają na
                    kobiety z pokolenia kanapkowego
                  </p>
                </div>
                <div className="flex items-start" data-id="element-227">
                  <BookOpenIcon className="h-5 w-5 text-pink-600 mr-2 mt-1 flex-shrink-0" data-id="element-228" />
                  <p className="text-gray-700" data-id="element-229">
                    5 wariantów 15-minutowej praktyki (na różne sytuacje)
                  </p>
                </div>
                <div className="flex items-start" data-id="element-230">
                  <BookOpenIcon className="h-5 w-5 text-pink-600 mr-2 mt-1 flex-shrink-0" data-id="element-231" />
                  <p className="text-gray-700" data-id="element-232">
                    Gotowe zdania do powiedzenia rodzinie, żeby uszanowali Twoje
                    15 minut
                  </p>
                </div>
                <div className="flex items-start" data-id="element-233">
                  <BookOpenIcon className="h-5 w-5 text-pink-600 mr-2 mt-1 flex-shrink-0" data-id="element-234" />
                  <p className="text-gray-700" data-id="element-235">
                    Plan 21-dniowy - jak wprowadzić metodę bez wyrzutów sumienia
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Transformation story */}
        <div className="bg-gray-50 rounded-lg shadow-md p-6 md:p-8 mb-12" data-id="element-236">
          <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-237">
            Pierwszy dzień nowego życia
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-238">
            E-book proponował start od jednej, prostej rzeczy: 15-minutowy
            "milczący rytuał". Bez telefonu, bez sprzątania, bez produktywności.
            Tylko ja i cisza.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-239">
            Brzmiało to absurdalnie prosto. I właśnie dlatego postanowiłam
            spróbować.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-240">
            Następnego ranka, zanim wszyscy wstali, zrobiłam sobie herbatę i
            usiadłam przy oknie. Ustawiłam timer na 15 minut.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-241">
            Pierwsze 5 minut to była tortura. Myśli goniły jak oszalałe:
            "Powinnam wstawić pranie", "Trzeba kupić chleb", "Mama pewnie zaraz
            wstanie".
          </p>
          <p className="text-gray-700 mb-4" data-id="element-242">Ale potem... coś się zmieniło.</p>
          <p className="text-gray-700 mb-4" data-id="element-243">
            Jakby mój mózg w końcu zrozumiał, że może się zatrzymać. Że świat
            się nie zawali, jeśli przez 15 minut nie będę niczyjną funkcją.
          </p>
          <p className="text-gray-700 font-bold" data-id="element-244">
            Kiedy timer zadzwonił, poczułam coś, czego nie czułam od lat.
            Spokój.
          </p>
        </div>
        {/* Results and pricing */}
        <div className="bg-white rounded-lg shadow-md border border-gray-200 p-6 md:p-8" data-id="element-245">
          <div className="md:flex" data-id="element-246">
            <div className="md:w-2/3 md:pr-8" data-id="element-247">
              <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-248">
                Dziś, trzy miesiące później
              </h3>
              <p className="text-gray-700 mb-4" data-id="element-249">
                Siedzę przy tym samym stole, przy którym trzy miesiące temu
                eksplodowałam o kubek. Mama śpi spokojnie w swoim pokoju. Dzieci
                odrabiają lekcje. Mąż robi kolację (tak, on!).
              </p>
              <p className="text-gray-700 mb-4" data-id="element-250">
                A ja piszę te słowa, bo wiem, że gdzieś tam jest kobieta, która
                dziś stoi w swojej kuchni i czuje, że zaraz eksploduje. Która
                myśli, że jest słaba. Która ma dość bycia wszystkim dla
                wszystkich.
              </p>
              <p className="text-gray-700 mb-6 font-bold" data-id="element-251">
                Chcę jej powiedzieć: nie jesteś sama. I nie musisz tak żyć.
              </p>
              <h4 className="text-lg font-bold text-gray-800 mt-8 mb-4" data-id="element-252">
                To nie jest magia. To nauka.
              </h4>
              <p className="text-gray-700 mb-4" data-id="element-253">
                Dr Radacka miała rację. Nasz mózg naprawdę potrzebuje tych 15
                minut jak płuca potrzebują powietrza. To nie fanaberia. To
                biologiczna konieczność.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-254">
                E-book "Nie Zapomnij o Sobie" nie zmienił mojego życia w sposób,
                jakiego oczekiwałam. Nie sprawił, że obowiązki zniknęły. Nie
                nauczył mnie być "superwoman".
              </p>
              <p className="text-gray-700 font-bold" data-id="element-255">
                Nauczył mnie czegoś znacznie ważniejszego - że mam prawo być
                człowiekiem. Że mam prawo być zmęczona. I że 15 minut dziennie
                może być różnicą między przetrwaniem a życiem.
              </p>
            </div>
            <div className="md:w-1/3 mt-8 md:mt-0" data-id="element-256">
              <div className="bg-gray-50 rounded-lg p-6 border border-gray-200 shadow-sm" data-id="element-257">
                <div className="text-center mb-4" data-id="element-258">
                  <h4 className="text-lg font-bold text-gray-800" data-id="element-259">
                    E-book "Nie Zapomnij o Sobie"
                  </h4>
                  <p className="text-sm text-gray-600" data-id="element-260">
                    Protokół 15-minutowej regeneracji
                  </p>
                </div>
                <div className="flex justify-center items-center mb-4" data-id="element-261">
                  <div className="text-gray-400 line-through mr-3" data-id="element-262">
                    <span className="text-lg" data-id="element-263">47,00 zł</span>
                  </div>
                  <div className="text-3xl font-bold text-red-600" data-id="element-264">
                    27,99 zł
                  </div>
                </div>
                <div className="text-center text-sm text-gray-600 mb-6" data-id="element-265">
                  <p data-id="element-266">To mniej niż kawa przez tydzień!</p>
                </div>
                <div className="space-y-3 mb-6" data-id="element-267">
                  <div className="flex items-start" data-id="element-268">
                    <CheckCircleIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-269" />
                    <p className="text-gray-700 text-sm" data-id="element-270">
                      Natychmiastowy dostęp po płatności
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-271">
                    <FileTextIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-272" />
                    <p className="text-gray-700 text-sm" data-id="element-273">
                      Format PDF - czytasz na telefonie, tablecie, komputerze
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-274">
                    <ShieldIcon className="h-5 w-5 text-green-600 mr-2 flex-shrink-0" data-id="element-275" />
                    <p className="text-gray-700 text-sm" data-id="element-276">
                      Gwarancja zwrotu pieniędzy przez 30 dni
                    </p>
                  </div>
                </div>
                <a href="https://veiramode.com/products/nie-zapomnij-o-sobie-ebook" className="block w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 px-4 rounded-lg text-center shadow-lg transform hover:scale-105 transition-all" data-id="element-277">
                  ZAMÓW E-BOOK TERAZ
                </a>
                <div className="mt-4 text-center" data-id="element-278">
                  <p className="text-sm text-gray-600" data-id="element-279">
                    Oferta ograniczona czasowo:
                  </p>
                  <CountdownTimer hours={5} minutes={45} seconds={22} data-id="element-280" />
                </div>
                <div className="mt-4 text-center" data-id="element-281">
                  <p className="text-xs text-gray-500" data-id="element-282">
                    Bezpieczna płatność: Przelewy24, BLIK, karta
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};